import {Country} from '../../country';
import {Sex} from '../../dropdown-options';
import {Province} from '../../province';
import {State} from '../../state';
import {MIBCodedReport, MIBIAIReport} from './mib-report';

export interface MIBReply {
  type: MIBReplyType;
  qualityMatchProbability?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  prefix?: string;
  suffix?: string;
  occupation?: string;
  sex?: Sex;
  birthday?: string;
  birthCountry?: Country;
  birthState?: Province | State;
  alternateBirthdays?: string[];
  residenceCountry?: Country;
  residenceTerritory?: string;
  residenceState?: Province | State;
  mibCodedReports?: MIBCodedReport[];
  mibIAIReports?: MIBIAIReport[];
}

export enum MIBReplyType {
  HIT = 'HIT',
  TRY = 'TRY',
}
